import React from 'react';
import { MedicationRequestOutputDto } from 'graphql/generated/remote-schema-hasura';
import MedicationHeader from './MedicationHeader';
import MedicationRow from './MedicationRow';
import MedicationMobile from './MedicationMobile';
import ShowOnMapModal from './ShowOnMapModal';
import { twMerge } from 'tailwind-merge';

const MedicationCard: React.FC<{
  medication: MedicationRequestOutputDto[];
  locale: Record<string, string>;
  hideHeader?: boolean;
  className?: string;
  isQuestionnaireMedication?: boolean;
}> = ({
  medication,
  locale,
  hideHeader = false,
  className,
  isQuestionnaireMedication = false,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [address, setAddress] = React.useState('');

  const handleSetAddress = (address: string) => {
    setAddress(address);
    setIsOpen(true);
  };

  if (!medication) {
    return null;
  }
  return (
    <div
      data-testid={`medication-${medication[0]?.prescriptionFhirId}`}
      className={twMerge(
        'rounded-10 border border-gray-opacity-15 overflow-hidden',
        className,
      )}
    >
      {!hideHeader && (
        <MedicationHeader
          {...medication[0]}
          locale={locale}
          isQuestionnaireMedication={isQuestionnaireMedication}
        />
      )}
      <div className="gap-2.5 py-4 bg-neutral-100 overflow-hidden hidden desktop:grid grid-cols-15 w-full px-30 text-charcoal-gray text-base font-semibold">
        <div className="col-span-2">Medication</div>
        <div className="col-span-2">{locale?.strength || 'Strength'}</div>
        <div className="col-span-2 whitespace-nowrap">
          {locale?.days || 'Days Supply'}
        </div>
        <div className="col-span-1">{locale?.quantity || 'Quantity'}</div>
        <div className="col-span-2">{locale?.dosageForm || 'Dosage Form'}</div>
        <div className="col-span-2">{locale?.nds || 'NDC'}</div>
        <div className="col-span-2">{locale?.duration || 'Duration'}</div>
        <div className="col-span-2">{locale?.pharmacy || 'Pharmacy'}</div>
      </div>
      {medication?.map((med) => (
        <React.Fragment key={med.prescriptionFhirId}>
          <MedicationRow {...med} setAddress={handleSetAddress} />
          <MedicationMobile
            medication={med}
            locale={locale}
            setAddress={handleSetAddress}
          />
        </React.Fragment>
      ))}

      <ShowOnMapModal isOpen={isOpen} setIsOpen={setIsOpen} address={address} />
    </div>
  );
};

export default MedicationCard;
